import React from "react";
import { Chip } from "@mui/material";

const getStatusColor = (status) => {
  switch (status) {
    case "captured": return { backgroundColor: "#d1fae5", color: "#065f46" };
    case "failed":
    case "refunded": return { backgroundColor: "#fee2e2", color: "#991b1b" };
    case "cancelled": return { backgroundColor: "#fef9c3", color: "#92400e" };
    case "pending": return { backgroundColor: "#e0f2fe", color: "#0369a1" };
    default: return {};
  }
};

export default function StatusChip({ status }) {
  return (
    <Chip
      label={status}
      size="small"
      sx={{
        fontWeight: 600,
        borderRadius: "16px",
        px: 1.5,
        ...getStatusColor(status),
      }}
    />
  );
}
